import { Column } from 'react-table';
import clsx from 'clsx';
import TablePagination from '../../../Tables/base/TablePagination';
import ImportProductsHeader from './ImportProductsHeader';
import ImportProductsBody from './ImportProductsBody';
import ImportProductsFooter from './ImportProductsFooter';
import { useRecordTable } from '../../../../hooks/useRecordTable';
import { ImportProduct } from '../../../../types/purchases/BasePurchase';

export type ImportCustomColumn = Column<ImportProduct> & {
  customCell?: (cell: any) => JSX.Element | string;
  className?: string;
};

interface ImportRecordTableProps {
  columns: ImportCustomColumn[];
  data: ImportProduct[];
  pageSize?: number;
  noDataMessage?: string;
  tableHeaderContent?: React.ReactNode;
  maxWidth?: string;
}

const ImportProductsViewTable = ({
  columns,
  data,
  pageSize = 10,
  noDataMessage = 'No hay registros de importación.',
  tableHeaderContent,
  maxWidth = 'max-w-6xl',
}: ImportRecordTableProps) => {
  const table = useRecordTable<ImportProduct>({ columns, data, pageSize });

  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      {/* Título y botón u otro contenido */}
      {tableHeaderContent && (
        <div className="mb-4 flex items-center justify-between px-4 pt-4">
          {tableHeaderContent}
        </div>
      )}

      {/* Tabla */}
      <section className="data-table-common data-table-two border-b border-t border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table min-w-[1500px] table-auto border-collapse break-words"
          >
            <ImportProductsHeader table={table} showFilters={true} />
            <ImportProductsBody table={table} noDataMessage={noDataMessage} />
            <ImportProductsFooter data={table.memoizedData} />
          </table>
        </div>

        {/* Paginación */}
        <TablePagination table={table} />
      </section>
    </div>
  );
};

export default ImportProductsViewTable;
